import { t } from "@bezbolisno/i18n";
import { can } from "@bezbolisno/kit/rbac";
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { isUuid } from "../../../lib/ids";
import { InvoiceDetailScreen } from "../../../screens/invoices/invoice-detail-screen";
import { invoiceDetailQuery } from "../../../screens/invoices/queries";
import { LoadErrorScreen, NotFoundScreen } from "../../../screens/invoices/shared";

export const Route = createFileRoute("/_authed/invoices/$invoiceId")({
  beforeLoad: ({ context, params }) => {
    // A malformed id is a 404 page, not a request (the API would answer 400 `invalid_id`).
    if (!isUuid(params.invoiceId)) throw notFound();
    if (!can(context.session.role, "patient:read")) throw redirect({ to: "/" });
  },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(invoiceDetailQuery(params.invoiceId)),
  errorComponent: () => <LoadErrorScreen title={t.invoices.title} />,
  notFoundComponent: NotFoundScreen,
  component: () => {
    const { invoiceId } = Route.useParams();
    const { session } = Route.useRouteContext();
    return <InvoiceDetailScreen invoiceId={invoiceId} role={session.role} />;
  },
});
